import React, { useEffect } from "react";
import "../style.css";

function Spinner({ msg, progress }) {
  useEffect(() => {}, [progress]);

  return (
    <div className="w-full h-full px-10 flex flex-col justify-center items-center">
      <div className="text-base text-zinc-200 font-bold mb-5">{msg}</div>
      {progress && (
        <progress
          className="progress progress-info w-72"
          value={Number.parseInt(progress)}
          max="100"
        ></progress>
      )}
    </div>
  );
}

export default Spinner;
